import request from '../utils/request'
import QS from "qs";

export function goodsList (data) {
  return request({
    url: '/api/goods',
    method: 'get',
    params:data,
  })
}
export function goodsListDes (id,data) {
  return request({
    url: `/api/goods/${id}`,
    method: 'get',
    params: data,
  })
}
export function getShopDes (id) {
  return request({
    url: `/api/shop/${id}`,
    method: 'get',
  })
}
// /api/poly/shop/{id}
export function getShop (id) {
  return request({
    url: `/api/poly/shop/${id}`,
    method: 'get',
  })
}
export function payPoly (data) { // 支付付款
  return request({
    url: '/api/poly/pay',
    method: 'post',
    data:QS.stringify(data),
  })
}
// /api/poly/pay
export function checkoutGoodsDes (id,data) { // 立即购买（单商品）结算
  return request({
    url: `/api/goods/${id}/checkout`,
    method: 'get',
    params: data,
  })
}
export function goodsCollect (id,data) {
  return request({
    url: `/api/goods/${id}/collect`,
    method: 'put',
    params:data,
  })
}
export function shopCollect (id,data) {
  return request({
    url: `/api/shop/${id}/follow`,
    method: 'put',
    params:data,
  })
}
export function addressList () {
  return request({
    url: '/api/user/address',
    method: 'get',
  })
}
export function addCart (data) {
  return request({
    url: '/api/cart',
    method: 'post',
    data:QS.stringify(data),
  })
}
export function addAddress (data) {
  return request({
    url: '/api/user/address',
    method: 'post',
    data:QS.stringify(data),
  })
}
export function addressEdit (id,data) {
  return request({
    url: `/api/user/address/${id}`,
    method: 'put',
    data:QS.stringify(data),
  })
}
export function addressDel (id) {
  return request({
    url: `/api/user/address/${id}`,
    method: 'delete'
  })
}
export function orderPay (data) {
  return request({
    url: '/api/goods/order',
    method: 'post',
    data:QS.stringify(data),
  })
}
export function orderPayMoney (id,type,data) {
  return request({
    url: `/api/payment/${id}/${type}`,
    method: 'post',
    data:QS.stringify(data),
  })
}
export function goodsSku(id){
  return request({
    url: `/api/trace-goods-specification/${id}`,
    method: 'get',
  })
}
export function collectList (data) {
  return request({
    url: '/api/user/collect',
    method: 'get',
    params:data,
  })
}
export function onePay () {
  return request({
    url: '/api/goods/onepay',
    method: 'get',
    // params:data,
  })
}
export function takeGood (id) {
  return request({
    url: `/api/user/order/${id}/take-goods`,
    method: 'put'
  })
}

export function discountCouponList (id) {
  return request({
    url: `/api/shop/${id}/bonus`,
    method: 'get',
  })
}

export function getDiscountCoupon (id) { // 领取优惠券
  return request({
    url: `/api/shop/${id}/bonus-get`,
    method: 'post',
  })
}
// /api/user/bonus
export function myBonusList (data) {
  return request({
    url: 'api/user/bonus',
    method: 'get',
    params:data,
  })
}
// /api/user/bonus/redeem-code
export function redeemCode (data) { // 兑换优惠券
  return request({
    url: 'api/user/bonus/redeem-code',
    method: 'post',
    data:QS.stringify(data),
  })
}
